export type BillingsOrderRailyTaxiRecalculateRequestBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate?: Date;
  checkoutEventId?: string;
  plannedDate?: Date;
  orderId?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export enum BillingsOrderRailyTaxiRecalculateRequestPenaltyType {
  OPTIMIZATION_REFUSED = "OPTIMIZATION_REFUSED",
  BEING_LATE = "BEING_LATE",
  INCOMPATIBLE_CAR = "INCOMPATIBLE_CAR",
  HIGHWAY_NOT_ALLOWED = "HIGHWAY_NOT_ALLOWED",
  SUBOPTIMAL_RIDE = "SUBOPTIMAL_RIDE",
  GUIDELINE_IGNORED = "GUIDELINE_IGNORED",
  OTHER = "OTHER",
}

export enum BillingsOrderRailyTaxiRecalculateRequestBonusType {
  DISTANCE_RATE_CHANGED = "DISTANCE_RATE_CHANGED",
  HALTING_RATE_CHANGED = "HALTING_RATE_CHANGED",
  SHORT_ROUTE = "SHORT_ROUTE",
  OTHER = "OTHER",
}

export type BillingsOrderRailyTaxiRecalculateRequestBody = {
  billingNodes: BillingsOrderRailyTaxiRecalculateRequestBillingNode[];
  bonus: number;
  penalty: number;
  penaltyType?: BillingsOrderRailyTaxiRecalculateRequestPenaltyType;
  bonusType?: BillingsOrderRailyTaxiRecalculateRequestBonusType;
};

type BillingsOrderRailyTaxiRecalculateRequest = {
  orderUuid: string;
  billingNodes: BillingsOrderRailyTaxiRecalculateRequestBillingNode[];
  bonus: number;
  penalty: number;
  penaltyType?: BillingsOrderRailyTaxiRecalculateRequestPenaltyType;
  bonusType?: BillingsOrderRailyTaxiRecalculateRequestBonusType;
};

export default BillingsOrderRailyTaxiRecalculateRequest;
